<template>
  <div class="titleClass">
    <stepPan :currStep="0"></stepPan>
    <div id="templatesP">
      <el-scrollbar>
        <div id="templatesDiv">
          <noticeBar noticeInfo="包月套餐"></noticeBar>
          <div>
            <div
              class="card"
              v-for="temp in templatesDataForMonthsLength"
              :key="temp.templateId"
            >
              <div class="imgDiv">
                <img
                  class="controlWidthCalss"
                  v-bind:src="
                    '/md/front/shopping/cart/template/getChargeTemplatesLogoImage/' +
                    temp.templateId
                  "
                  alt="充值模板图片无法加载"
                />
              </div>
              <div class="pricePan">
                <checkboxCom
                  :tempId="temp.templateId"
                  :showLable="temp.cardLabel"
                  v-on:addToTempsArrayEvent="addOneTempToTempsArrayFun"
                  v-on:removeFromTempsArrayEvent="delOneTempFromTempsArrayFun"
                  v-on:numValueChangeEvent="numChangeFun"
                >
                </checkboxCom>
              </div>
            </div>
          </div>
          <noticeBar noticeInfo="下载套餐"></noticeBar>
          <div>
            <div
              class="card"
              v-for="temp in templatesDataForPointCart"
              :key="temp.templateId"
            >
              <div class="imgDiv">
                <img
                  class="controlWidthCalss"
                  v-bind:src="
                    '/md/front/shopping/cart/template/getChargeTemplatesLogoImage/' +
                    temp.templateId
                  "
                  alt="充值模板图片无法加载"
                />
              </div>
              <span>
                <checkboxCom
                  :tempId="temp.templateId"
                  :showLable="temp.cardLabel"
                  v-on:addToTempsArrayEvent="addOneTempToTempsArrayFun"
                  v-on:removeFromTempsArrayEvent="delOneTempFromTempsArrayFun"
                  v-on:numValueChangeEvent="numChangeFun"
                >
                </checkboxCom>
              </span>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div id="nextPan">
      <span class="priceBlock info1"> {{ sumPriceInfo }}</span>
      <span class="priceBlock info2">
        <el-switch
          v-model="withInvoice"
          active-color="#13ce66"
          inactive-color="#ff4949"
          v-on:change="reCalculateSumMoney"
        >
        </el-switch>
        <span v-if="withInvoice">带发票 ( {{ invoicePrompt }} )</span>
        <span v-else>不带发票</span>
      </span>
      <span class="priceBlock">
        <el-button
          class="mybn"
          size="small"
          type="primary"
          :disabled="nextStepButtonDisabled"
          @click="nextStepFun"
          >提 交</el-button
        >
      </span>
    </div>
  </div>
</template>

<script>
import stepPan from '../tools/setps.vue'
import noticeBar from '../tools/noticeBar.vue'
import checkboxCom from '../checkBoxLabel/encapsulation.vue'

export default {
  emits: ['nextStepEvent'],
  created () {
    // 加载税点和发票邮资
    const api = '/md/front/shopping/cart/invoice/getInfo'
    this.axios.post(api).then(res => {
      if (res.status === 200 && res.data.tag) {
        res = res.data
        this.postage = res.postage
        this.taxPoint = res.taxPoint
        this.invoicePrompt = '加收' + this.taxPoint + '个点税率和' + this.postage + '元快递费'
      }
    })
  },
  mounted () {
    // 加载当前后台所有的可用充值模板
    const api = '/md/front/shopping/cart/template/getAllChargeTemplates'
    this.axios.post(api).then(res => {
      if (res.status === 200) {
        // 获取所有交易模板
        this.templatesData = res.data
        this.groupTemplateForPointCart()
        this.changeDataToArrayJSON()
      }
    })
  },
  data () {
    return {
      templatesData: null, // 用户可以购买的所有模板json数组
      templatesDataForPointCart: null, // 所有点卡模板
      templatesDataForMonthsLength: null, // 所有月费模板
      templatesDataArrayJSON: [], // 模板选择后的计数数组
      withInvoice: false, // 是否开发票
      sumPriceStr: '0', // 用户总共需要支付的金额
      nowShoppingCartId: null, // 现在的购物车id, 给下一步使用
      nextStepButtonDisabled: true, // 只有用户选择了一个以上的模板才可以点击下一步
      sumPriceInfo: '共计 0 元', // 订单总金额（因为之前需要除100  所以单独拿出来）
      invoicePrompt: '加收6个点税率和25元快递费', // 带发票提示
      taxPoint: 6, // 税点
      postage: 25 // 发票邮资
    }
  },
  methods: {
    // 将后台获得的数据根据点数或时长进行分组(分组后每组之间的顺序无法确定)
    groupTemplateForPointCart () {
      // 将所有的点卡模板数据过滤为一个数组
      this.templatesDataForPointCart = this.templatesData.filter(
        temp => temp.payByPointOrTimeSpace === 1
      )
      this.templatesDataForPointCart.forEach(value => {
        value.cardLabel =
          value.perMoney / 100 + '元' + value.pointsNumOrTimeLength + '点'
      })
      // 将所有的年费模板数据过滤为一个数组
      this.templatesDataForMonthsLength = this.templatesData.filter(
        temp => temp.payByPointOrTimeSpace === 2
      )
      this.templatesDataForMonthsLength.forEach(value => {
        value.cardLabel =
          value.perMoney / 100 + '元' + value.pointsNumOrTimeLength + '月'
      })
    },
    // 将后台获得的数据放入json数组里面(后台数据里面没有是否检查和数量的属性, 需要转换)
    changeDataToArrayJSON () {
      for (const i in this.templatesData) {
        const key = this.templatesData[i].templateId
        const pNumsOrTLength = this.templatesData[i].pointsNumOrTimeLength
        const perMoney = this.templatesData[i].perMoney
        const initJSON = {
          checked: false,
          num: 1,
          tempId: key,
          pNumsOrTLength: pNumsOrTLength,
          perMoney: perMoney
        }
        this.templatesDataArrayJSON[`${key}`] = initJSON
      }
      // console.log(this.templatesDataArrayJSON)
      // payByPointOrTimeSpace == 0  perMoney 元  pointsNumOrTimeLength 月 `````````````````````````
    },
    // 设置模板数组内某一个模板购买的值为真
    addOneTempToTempsArrayFun (tempId) {
      this.templatesDataArrayJSON[`${tempId}`].checked = true
      this.reCalculateSumMoney()
    },
    // 设置模板数组内某一个模板购买的值为假
    delOneTempFromTempsArrayFun (tempId) {
      this.templatesDataArrayJSON[`${tempId}`].checked = false
      this.reCalculateSumMoney()
    },
    // 当某一个要购买的模板的数量发生变化时
    numChangeFun (tempId, num) {
      this.templatesDataArrayJSON[`${tempId}`].num = parseInt(num)
      this.reCalculateSumMoney()
    },
    // 重新计算总的价格(数据清洗->新建购物车)
    reCalculateSumMoney () {
      // 过滤没有勾选的模板
      const realDataArray = this.templatesDataArrayJSON.filter(
        temp => temp.checked === true
      )
      // console.log(realDataArray)
      let sumMoney = 0
      realDataArray.forEach(temp => {
        sumMoney = sumMoney + temp.num * temp.perMoney
      })
      if (sumMoney !== 0) {
        this.nextStepButtonDisabled = false
        if (this.withInvoice) {
          // sumMoney = sumMoney * 1.06 + 2500
          // sumMoney = Math.floor(sumMoney) // 舍弃小数点 // ceil向上取整
          const sl = 1 + this.taxPoint / 100 // 税率总百分百
          const yz = parseInt(this.postage) // 邮资
          const tempMoneyTotal = Math.floor((sumMoney / 100) * sl) + yz
          sumMoney = tempMoneyTotal * 100
        }
      } else {
        this.nextStepButtonDisabled = true
      }
      this.sumPriceStr = sumMoney
      this.sumPriceInfo = '共计 : ' + this.sumPriceStr / 100 + ' 元'
    },
    // 重新创建一个购物车(新建购物车->刷新当前总金额)
    tryToCreateOneShoppingCart: async function (tempArray, tempNumArray) {
      if (tempArray.length === 0) {
        this.sumPriceStr = '0' // 当前没有任何模板被选中, 总金额为0
        this.nextStepButtonDisabled = true // 下一步按钮被禁用
        return
      }
      this.sumPriceInfo = '跳转中......'
      // 加载当前后台所有的可用充值模板
      const api = '/md/front/shopping/cart/createOneLog'
      let params = {
        templateIds: tempArray,
        numbers: tempNumArray,
        withInvoice: this.withInvoice
      }
      // 如果发送的内容里面有数组, 一定要加 { indices: false } 的配置, 否则后台无法接收参数
      params = this.$qs.stringify(params, { indices: false })
      const res = await this.axios.post(api, params)
      if (res.status === 200) {
        // 获取总的交易金额
        const nowShoppingCartId = parseInt(res.data)
        this.nowShoppingCartId = nowShoppingCartId
        // 触发下一步的事件
        this.$emit('nextStepEvent', this.nowShoppingCartId)
      }
    },
    // 触发下一步的事件
    nextStepFun () {
      if (this.nextStepButtonDisabled === false) {
        // 过滤没有勾选的模板
        const realDataArray = this.templatesDataArrayJSON.filter(
          temp => temp.checked === true
        )
        const tempArray = []
        const tempNumArray = []
        realDataArray.forEach(temp => {
          tempArray.push(temp.tempId)
          tempNumArray.push(temp.num)
        })
        // console.log(tempArray)
        // console.log(tempNumArray)
        this.tryToCreateOneShoppingCart(tempArray, tempNumArray)
      }
    }
  },
  components: {
    checkboxCom, // 将elementUI里面的checkbox组件进行封装
    stepPan,
    noticeBar
  }
}
</script>

<style scoped>
#templatesP {
  overflow: hidden;
  height: -webkit-calc(100vh - 300px);
  height: -moz-calc(100vh - 300px);
  height: calc(100vh - 300px);
}

#templatesDiv {
  overflow: auto;
}
.priceBlock {
  display: inline-block;
}
.info1 {
  color: #fff;
  font-size: 20px;
  font-weight: 800;
}
.info2 {
  margin-left: 50px;
  width: 380px;
  color: #fff;
  font-size: 15px;
  text-align: left;
}

.priceInfo {
  color: #fff;
  font-size: 16;
  font-weight: 500;
  line-height: 30px;
}
.controlWidthCalss {
  width: 250px;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
  border: 1px solid #963;
  -moz-box-shadow: 2px 2px 5px #333333;
  -webkit-box-shadow: 2px 2px 5px #333333;
  box-shadow: 2px 2px 5px #333333;
}
.titleClass {
  color: red;
}
.card {
  width: 350px;
  display: inline-block;
}

.imgDiv {
  width: 100%;
  padding: 5px;
  text-align: center;
}

.pricePan {
  width: 100%;
  text-align: center;
  height: 40px;
}
.mybn {
  background-color: transparent;
  width: 100px;
}

#templatesP :deep(.el-scrollbar) {
  height: 100%;
  width: 100%;
}
#templatesP :deep(.el-scrollbar__wrap) {
  overflow-x: hidden;
}
</style>
